import { Text } from '../Text/Text';
import { COLORS, device } from '../../constants';
import { Select } from '../Select/Select';
import React from 'react';
import styled from 'styled-components';

interface FilterSectionItemProps {
  title: string;
  optionList: string[];
  isMultiple: boolean;
  onChange: (selected: string[]) => void;
  selectedOptions: string[];
  searchEnabled?: boolean;
  listMaxHeight?: string;
}

const FilterSectionItem = ({
  title,
  optionList,
  selectedOptions,
  isMultiple,
  onChange,
  searchEnabled,
  listMaxHeight,
}: FilterSectionItemProps) => {
  return (
    <FilterSectionItemContainer>
      <TextWrapper>
        <Text text={title} size={22} weight={700} color={COLORS.SECTION_TEXT} />
      </TextWrapper>
      <Select
        optionsList={optionList}
        isMultiple={isMultiple}
        onChange={onChange}
        selectedOptions={selectedOptions}
        searchEnabled={searchEnabled}
        listMaxHeight={listMaxHeight}
      />
    </FilterSectionItemContainer>
  );
};

const FilterSectionItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media screen and (${device.sm}) {
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
`;

const TextWrapper = styled.div`
  min-height: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (${device.md}) {
    > h4 {
      font-size: 14px;
      line-height: 1.5;
    }
  }
  @media screen and (${device.sm}) {
    > h4 {
      min-height: auto;
    }
  }
`;

export { FilterSectionItem };
